import { InternalChainIdSchema } from "../chains";
import z from "zod";

export enum PartnerCategory {
  CEDE = "Panda cuddlers 🐼",
  PERPS = "Perpetual",
  DEX = "DEX",
  LENDING = "Lending",
  FOUNDATION = "Foundation",
  STAKING = "Staking",
  EARNING = "Earning",
  HEDGE = "Hedge",
  YIELD = "Yield",
  RESTACKING = "Restacking",
  CDP = "CDP",
  ANALYTICS = "Analytics",
  DISCOVER = "Discover",
}

export enum PartnerIds {
  LOCALHOST = 0,
  REF_FI = 1,
  LOG_X = 2,
  KRYA = 3,
  BUCKET = 4,
  CHIMP = 5,
  MARGINED = 6,
  VELOCIMETER = 7,
  DIVERCEFI = 8,
  HORIZON = 9,
  SYNCSWAP = 10,
  BASE = 11,
  LINEA = 12,
  STACKS = 13,
  ARCHWAY = 14,
  SHARDEUM = 15,
  CORE = 16,
}

export const PartnerSchema = z.object({
  url: z.string(),
  host: z.string(),
  id: z.nativeEnum(PartnerIds),
  title: z.string(),
  logo: z.string(),
  categories: z.array(z.nativeEnum(PartnerCategory)),
  icids: z.array(InternalChainIdSchema),
  // twitter_handle - DEPRECATED ONCE STORE-1796 is RELEASED
  twitter_handle: z.string().nullable().optional(),
  twitterHandle: z.string(),
  refererSource: z.string().nullable().optional(),
});

export type Partner = z.infer<typeof PartnerSchema>;
